import { COLORS } from '@/constants'

type FiltersIconProps = {
  active?: boolean
}

export const FiltersIcon = ({ active }: FiltersIconProps) => {
  const iconColor = COLORS['secondary/500']
  const fillColor = active === true ? iconColor : 'none'
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.90497 8.3374C4.24601 7.09707 3.06376 5.73277 2.41823 4.96578C2.2184 4.72835 2.15292 4.5546 2.11355 4.24853C1.97874 3.20053 1.91134 2.67653 2.21863 2.33827C2.52593 2 3.06936 2 4.15622 2H11.8438C12.9307 2 13.4741 2 13.7813 2.33827C14.0887 2.67653 14.0213 3.20053 13.8865 4.24854C13.8471 4.55461 13.7816 4.72836 13.5817 4.96578C12.9353 5.73375 11.7507 7.10047 10.0884 8.34233C9.938 8.45473 9.83887 8.6378 9.82047 8.84093C9.6558 10.6613 9.50393 11.6584 9.4094 12.1628C9.25687 12.9771 8.10213 13.4671 7.484 13.9042C7.11607 14.1644 6.66953 13.8547 6.62185 13.4519C6.53095 12.6841 6.35974 11.1243 6.17285 8.84093C6.15606 8.63593 6.05657 8.45073 5.90497 8.3374Z"
        fill={fillColor}
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
